import { createSlice } from '@reduxjs/toolkit';

import * as REQUESTS from '../api/gamerRequests';
import { setAlert } from './alertSlice';

import { loadUser } from './authSlice';

const initialState = {
  allGamers: null,
  filteredGamers: null,
  gamer: null,
  recentUpdate: null,
  deletedUpdate: null,
  loading: false,
  followedUser: null,
  unfollowedUser: null,
  friendRequestLoading: false,
};

const gamerSlice = createSlice({
  name: 'gamer',
  initialState,
  reducers: {
    setAllGamers(state, action) {
      state.allGamers = action.payload;
      state.filteredGamers = action.payload;
      state.loading = false;
    },
    setRecentUpdate(state, action) {
      state.recentUpdate = action.payload;
      state.loading = false;
    },
    setDeletedUpdate(state, action) {
      state.deletedUpdate = action.payload;
      state.loading = false;
    },
    setFilteredGamers(state, action) {
      state.filteredGamers = state.allGamers.filter((gamer) => {
        const regex = new RegExp(`${action.payload}`, 'gi');
        return gamer.name.match(regex) || gamer.username.match(regex);
      });
      state.loading = false;
    },
    setGamer(state, action) {
      state.gamer = action.payload;
      state.loading = false;
    },
    setFollowedUser(state, action) {
      state.followedUser = action.payload;
      state.friendRequestLoading = false;
    },
    setUnfollowedUser(state, action) {
      state.followedUser = action.payload;
      state.friendRequestLoading = false;
    },
    setLoading(state) {
      state.loading = !state.loading;
    },
    setfriendRequestLoading(state) {
      state.friendRequestLoading = !state.friendRequestLoading;
    },
  },
});

export const {
  setAllGamers,
  setLoading,
  setGamer,
  setDeletedUpdate,
  setRecentUpdate,
  setFollowedUser,
  setUnfollowedUser,
  setfriendRequestLoading,
  setFilteredGamers,
} = gamerSlice.actions;

export default gamerSlice.reducer;

// thunks

// get all gamers
export const getAllGamers = () => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.getAllUsers();
    const { success, data } = resData;

    if (success) {
      dispatch(setAllGamers(data));
    }
  } catch (err) {
    dispatch(setLoading());
    dispatch(setAlert('Error 2', 'danger'));
  }
};

// get all gamers
export const getGamer = (username) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.getUser(username);
    const { success, data } = resData;
    if (success) {
      dispatch(setGamer(data));
    }
  } catch (err) {
    dispatch(setLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

// add update
export const addUpdate = (update) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.addUpdate(update);
    const { success } = resData;
    if (success) {
      dispatch(setRecentUpdate(update));
      dispatch(loadUser());
      dispatch(setAlert('Update Added!', 'success'));
    }
  } catch (err) {
    dispatch(setLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

// add update
export const deleteUpdate = (update) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.deleteUpdate(update._id);
    const { success } = resData;
    if (success) {
      dispatch(setRecentUpdate(update));
      dispatch(loadUser());
      dispatch(setAlert('Update Deleted!', 'success'));
    }
  } catch (err) {
    dispatch(setLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

// follow user
export const followUser = (user) => async (dispatch) => {
  try {
    dispatch(setfriendRequestLoading());
    const resData = await REQUESTS.followUser(user._id);
    const { success } = resData;
    if (success) {
      dispatch(setFollowedUser(user));
      dispatch(loadUser());
      dispatch(setAlert(`You followed ${user.name}`, 'success'));
    }
  } catch (err) {
    dispatch(setfriendRequestLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};

// unfollow user
export const unfollowUser = (user) => async (dispatch) => {
  try {
    dispatch(setfriendRequestLoading());
    const resData = await REQUESTS.unfollowUser(user._id);
    const { success } = resData;
    if (success) {
      dispatch(setUnfollowedUser(user));
      dispatch(loadUser());
      dispatch(setAlert(`You unfollowed ${user.name}`, 'success'));
    }
  } catch (err) {
    dispatch(setfriendRequestLoading());
    dispatch(setAlert(err.response.data.error, 'danger'));
  }
};
